import { AHIcon } from "arkh";

import { TeamFeatureItem } from "./TeamFeatureItem";

import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";

export function TeamFeatureBarProductItem(props: {
  onPress: () => void;

  isGrid: boolean;
}) {
  const intl_tokens = useIntlTokens();

  return (
    <TeamFeatureItem
      icon={<AHIcon type="product" size="medium" />}
      title={intl_tokens.Products}
      isGrid={props.isGrid}
      onPress={() => {
        props.onPress();
      }}
    />
  );
}
